import React, { useState } from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
import { GreatMembersPointsSimulatorForm } from './form/GreatMembersPointsSimulatorForm';
import { GreatMembersPointsSimulatorResult } from './result/GreatMembersPointsSimulatorResult';
type Props = {
  className?: string;
  currencyCode: string;
  id: string;
};
export const GreatMembersPointsSimulator = ({ className, currencyCode, id }: Props) => {
  const [total, setTotal] = useState(null);
  return (
    <div
      className={classnames(
        'relative overflow-hidden rounded-12 bg-white shadow sm:flex',
        className,
      )}
      id={id}
    >
      <div className="flex items-center justify-center bg-lightSand p-20">
        <Icon
          className="text-black"
          isNotMonoChrome
          isNotSquare
          name={ICONS.CLUBMED_GREAT_MEMBERS_INTRO}
          width="12.5rem"
        />
      </div>
      <div className="flex-1 p-20">
        {!total ? (
          <GreatMembersPointsSimulatorForm
            currencyCode={currencyCode}
            onSubmit={(points) => setTotal(points)}
          />
        ) : (
          <GreatMembersPointsSimulatorResult onRecalculate={() => setTotal(null)} total={total} />
        )}
      </div>
    </div>
  );
};
